import React, { useEffect, useState } from "react";
import API from "../services/api";
import Sidebar from "../components/Sidebar";
import { toast } from "react-toastify";

function Timeline() {
  const [events, setEvents] = useState([]);
  const [dashboard, setDashboard] = useState(null);

  useEffect(() => {
    fetchTimeline();
    fetchDashboard();
  }, []);

  const fetchTimeline = async () => {
    try {
      const res = await API.get("/timeline");
      setEvents(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchDashboard = async () => {
    try {
      const res = await API.get("/dashboard/summary");
      setDashboard(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const markComplete = async (eventId) => {
    try {
      await API.put(`/timeline/${eventId}`, {
        status: "completed"
      });

      toast.success("Day marked complete");
      fetchTimeline();
    } catch {
      toast.error("Update failed");
    }
  };

  const progress =
    dashboard?.total_days > 0
      ? Math.round(
          (dashboard.current_day / dashboard.total_days) * 100
        )
      : 0;

  return (
    <div className="dashboard-layout">
      <Sidebar />

      <div className="main-content">
        <div className="container-fluid">

          {/* Header */}
          <div className="card dashboard-card mb-4 photo-card">
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <h5>📷 Daily Photo Reminder</h5>
                <p>
                  Capture a quick photo of your vermibed
                  to track daily progress.
                </p>
              </div>

              <button className="btn btn-success">
                Take Today's Photo
              </button>
            </div>
          </div>

          {/* Summary */}
          <div className="row g-4 mb-4">
            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Current Day</h6>
                <h2>
                  {dashboard?.current_day || 0}/
                  {dashboard?.total_days || 60}
                </h2>
                <small>
                  {(dashboard?.total_days || 60) -
                    (dashboard?.current_day || 0)}{" "}
                  days remaining
                </small>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Current Phase</h6>
                <span className="badge bg-primary p-2">
                  {dashboard?.current_phase || "Not Started"}
                </span>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card text-center">
                <h6>Progress</h6>

                <div className="progress mb-2">
                  <div
                    className="progress-bar bg-success"
                    style={{ width: `${progress}%` }}
                  ></div>
                </div>

                <h4>{progress}%</h4>
              </div>
            </div>
          </div>

          {/* Timeline Header */}
          <div className="card dashboard-card mb-4">
            <h3>📅 60-Day Timeline</h3>
            <p>Complete vermicomposting journey</p>
          </div>

          {/* Phase Cards */}
          <div className="row g-4 mb-4">
            <div className="col-md-4">
              <div className="card dashboard-card">
                <h5>Setup & Initial Feeding</h5>
                <p>Days 1–7</p>
                <h2>0/7</h2>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card">
                <h5>Regular Maintenance</h5>
                <p>Days 8–56</p>
                <h2>0/49</h2>
              </div>
            </div>

            <div className="col-md-4">
              <div className="card dashboard-card">
                <h5>Harvesting</h5>
                <p>Days 57–60</p>
                <h2>0/4</h2>
              </div>
            </div>
          </div>

          {/* Timeline Events */}
          {events.map((event) => (
            <div
              key={event.id}
              className="card dashboard-card mb-4"
            >
              <div className="d-flex justify-content-between align-items-start flex-wrap">
                <div>
                  <h4>
                    Day {event.event_day}

                    {event.status === "pending" && (
                      <span className="badge bg-primary ms-2">
                        Current
                      </span>
                    )}
                  </h4>

                  <span className="badge bg-info mb-3">
                    {dashboard?.current_phase}
                  </span>

                  <h5>{event.event_title}</h5>
                  <p>{event.description}</p>
                </div>

                <div className="d-flex gap-2">
                  <button className="btn btn-outline-secondary">
                    Go to Day
                  </button>

                  {event.status !== "completed" && (
                    <button
                      className="btn btn-dark"
                      onClick={() =>
                        markComplete(event.id)
                      }
                    >
                      Mark Complete
                    </button>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default Timeline;